
import Vue from "vue";
import Component from "vue-class-component";
import InputForm from "@/components/base/form/InputForm.vue";
import { Getter, State, Action } from "vuex-class";
import { FormConfig, FormValid } from "@/config";
@Component({
	name: "UnitBasic",
	components: { InputForm }
})
export default class UnitBasic extends Vue {
	@State("basic") private basic: any;
	@Getter("id") private id: any;
	@Getter("save") private isSave: any;
	@Getter("phone") private phone: any;
	@Getter("account") private account: any;
	isAuthern: number = 0;
	@Action("account/getPersonAuthernList") private getPersonAuthernList: any;
	@Action("account/getBasic") private getBasic: any;
	@Action("account/addBasic") private addBasic: any;
	$https: any;
	isEdit = false;
	formName: any = "CompanyBaseInfo";
	currentPage = 0;
	labelWidth: any = "180px";
	labelPosition: any = "left";
	btnData = "基本信息";
	// btnData = [
	//   "基本信息", "财务信息", "附件信息",
	// ];
	socialIdCard: any = this.$store.state.account.socialIdCard;
	input = "";
	setting: any = [
		{
			label: "手机号",
			ref: "phone",
			type: "input",
			span: 24,
			disabled: true,
			required: true,
			index: 1
		},
		{
			label: "账号名",
			ref: "account",
			type: "input",
			span: 24,
			disabled: true,
			required: true,
			index: 1
		},
		{
			label: "用户姓名",
			ref: "userName",
			type: "input",
			span: 24,
			disabled: true,
			required: true,
			index: 1
		},
		{
			label: "证件号码",
			ref: "papersNumber",
			type: "input",
			span: 24,
			disabled: true,
			required: true,
			index: 1
		}
	];
	formData: any = {
		papersNumber: "",
		userName: "",
		phone: "",
		account: ""
	};
	state = 0;
	edit() {
		this.isEdit = true;
		this.setting.forEach((el: any) => {
			if (this.isAuthern !== 1) {
				el.type = "input";
			} else {
				if (el.ref !== "cName" && el.ref !== "socialIdCard") {
					el.type = "input";
				}
			}
		});
	}
	created() {
		this.getSaveData();
		// if(this.isSave === 1) {
		//   this.setStatus();
		// }
	}
	setStatus() {
		this.isEdit = false;
		this.setting.forEach((el: any) => {
			el.type = "text";
		});
	}
	getSaveData() {
		const options = { unitId: this.id };
		this.getBasic(options).then(({ code, data, msg }: any) => {
			if (code === 0 && data) {
				const { userCode } = data;
				const { papersNumber, userName } = userCode;
				// 实名认证数据
				this.formData.papersNumber = papersNumber || null;
				this.formData.userName = userName;
				this.formData.account = this.account;
				this.formData.phone = this.phone;
				return data;
			}
		});
	}
	submit() {
		if (!(this.$refs.companyBaseInfo as any).validForm()) {
		}
	}
	save() {
		const {
			cName: unitName,
			unitNature,
			socialIdCard: creditCode,
			unitType: organizationType,
			industry: theirIndustry,
			reCapital: registeredCapital,
			address: detailedAddress,
			coAddress: registeredAddress,
			techField: belongsToField
		} = this.formData;
		const options = {
			unitName,
			unitNature: unitNature[0],
			creditCode,
			organizationType: organizationType[0],
			theirIndustry: theirIndustry[0],
			registeredCapital,
			registeredAddress,
			detailedAddress,
			belongsToField: belongsToField[0]
			// id: this.unitId,
		};
		this.addBasic(options).then(({ code, data, msg }: any) => {
			if (code === 0) {
				this.$message.success("提交成功");
				return data;
			}
		});
	}
	// save(type: any) {
	//   switch (type) {
	//   case 0: this.addBasicData();break;
	//   case 1: this.addBasicData();break;
	//   case 2: this.addBasicData();break;
	//   default: break;
	//   }
	// }
}
